export const TOUCH_UI_LOCAL_STORAGE_KEY = 'BAF:UI:isTouchUI'
